<script lang="ts">
	import Dollar from 'assets/svg/dollarIcon.svg?url';
	import Bitcoin from 'assets/svg/bitcoin.svg?url';
	import Euro from 'assets/svg/euroIcon.svg?url';
	import Ethereum from 'assets/svg/ethereum.svg?url';
	import { _ } from 'utils/i18/i18n';
	import type { IDropdownSelectorValue } from 'customTypes/dropdownSelector';
	import DropdownSelector from 'components/DropdownSelector/DropdownSelector.svelte';
	import { coinRankingReferenceCurrencies } from 'utils/coinRanking/coinRankingReferenceCurrencies';

	export let isMobileMenu: boolean = false;

	const values: IDropdownSelectorValue[] = [
		{
			icon: Dollar,
			title: $_('navigation.currency.dollar'),
			value: 'usd',
			id: coinRankingReferenceCurrencies.USD,
		},
		{
			icon: Bitcoin,
			title: $_('navigation.currency.bitcoin'),
			value: 'btc',
			id: coinRankingReferenceCurrencies.BTC,
		},
		{
			icon: Euro,
			title: $_('navigation.currency.euro'),
			value: 'eur',
			id: coinRankingReferenceCurrencies.EUR,
		},
		{
			icon: Ethereum,
			title: $_('navigation.currency.ethereum'),
			value: 'eth',
			id: coinRankingReferenceCurrencies.ETH,
		},
	];
</script>

<DropdownSelector {values} {isMobileMenu} />
